import { useState } from "react";
import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

export function Notification({ fields, scope }: ComponentProps) {
  const text = useBound<string>(fields.text as BoundValue, scope) ?? "";
  const variant = useBound<string>(fields.variant as BoundValue, scope) ?? "info";
  const dismissible = useBound<boolean>(fields.dismissible as BoundValue, scope) ?? false;
  const [hidden, setHidden] = useState(false);

  if (hidden || !text) return null;
  return (
    <div className={`a2-notification variant-${variant}`} role="status">
      <span>{text}</span>
      {dismissible && (
        <button
          className="a2-notification-close"
          onClick={() => setHidden(true)}
          aria-label="Dismiss"
        >×</button>
      )}
    </div>
  );
}
